var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasData
    ? _c(
        "div",
        {
          staticClass: "icon-cont",
          class: _vm.readOnly ? "read-only" : _vm.isSelected ? "active" : "",
          attrs: { title: _vm.channelData.label },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              _vm.readOnly || _vm.isDisabled || _vm.isSelected
                ? null
                : (_vm.showVerify = true)
            },
          },
        },
        [
          _c(_vm.svgIcon, {
            tag: "component",
            attrs: { label: _vm.channelData.label },
          }),
          _c(
            "v-dialog",
            {
              model: {
                value: _vm.showVerify,
                callback: function ($$v) {
                  _vm.showVerify = $$v
                },
                expression: "showVerify",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "confirmation-card" },
                [
                  _c(
                    "v-card-title",
                    {
                      staticStyle: {
                        "background-color": "#1c6e59",
                        color: "white",
                        "letter-spacing": "0.03rem",
                        height: "40px",
                      },
                      style: _vm.$vuetify.breakpoint.xsOnly
                        ? "text-align: center !important;"
                        : "",
                    },
                    [
                      _vm._v(
                        ' Assign "' + _vm._s(_vm.channelData.label) + '"? '
                      ),
                    ]
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { plain: "" },
                          on: {
                            click: function ($event) {
                              _vm.showVerify = false
                            },
                          },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: { click: _vm.selectChannel },
                        },
                        [_vm._v(" Assign ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }